import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const NavbarStyle = styled.div<{ $stepIconSize?: string }>`
  position: fixed;
  display: flex;
  top: 48px;
  left: 0px;
  z-index: 9;
  width: 100%;
  background: white;

  .header {
    width: 100%;
    position: fixed;
    top: 48px;
    left: 0;
    z-index: 2;

    .header-container {
      max-width: 376px;
      margin: 0 auto;
      width: 100%;
      display: flex;
      padding: 8px 16px;
      position: relative;
      background: white;
      align-items: center;
    }
  }

  .nav-container {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    width: 100%;
    max-width: 376px;
    margin: 0 auto;
    padding: 8px 16px;
    grid-gap: 8px;
  }

  .assistance-nav {
    position: relative;
    background: ${theme.neutrals.white};
    &.nav-container {
      grid-template-columns: min-content 1fr;
      align-items: center;
    }
  }

  .navbar-wrapper {
    background: white;
    margin: 0 auto;
    width: 100%;
    max-width: 376px;
    align-items: center;
    display: grid;
    grid-template-columns: 48px 1fr 48px;
  }
  .navbar-center {
    margin: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    .MuiLinearProgress-colorPrimary {
      background-color: ${(props) => props.theme.primary.primary10};
      .MuiLinearProgress-barColorPrimary {
        background-color: ${(props) => props.theme.primary.primary50};
      }
    }
    .MuiStepper-root {
      padding: 0;
      width: 100%;
      .MuiStepIcon-root {
        font-size: ${(props) => props.$stepIconSize ?? '22px'};
      }
      .MuiStep-root {
        padding: 0;
        display: flex;
        align-items: center;
      }
      .MuiStepConnector-root {
        flex: 1;
        .MuiStepConnector-line {
          border-color: ${(props) => props.theme.greys.grey050};
          border-top-width: 1px;
        }
      }
      .MuiStepConnector-root.Mui-active,
      .MuiStepConnector-root.Mui-completed {
        .MuiStepConnector-line {
          border-color: ${(props) => props.theme.primary.primary50};
        }
      }
      .MuiStepLabel-root {
        padding: 0 5px;
        .MuiStepLabel-labelContainer {
          display: none;
        }
      }
      .MuiStepLabel-iconContainer {
        padding: 0;
      }
    }
  }
  .navbar-left,
  .navbar-right {
    height: 100%;
    .MuiButtonBase-root {
      height: 52px;
    }
    button {
      width: 100%;
      height: 100%;
    }
  }
  &.custom-right {
    .navbar-wrapper {
      grid-template-columns: 160px 1fr 160px;
    }
  }

  &.resume {
    .navbar-wrapper {
      grid-template-columns: 160px 1fr 48px;
    }
  }

  &.service {
    .navbar-wrapper {
      grid-template-columns: 48px 1fr 1fr;
      .navbar-right {
        justify-self: end;
      }
    }
  }
`;
